import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { GetVehicle } from "../../Services";

const UpdateInsuranceStatus = ({ vehicle, setVehicles, setShowModal }) => {
  const [insuranceStatus, setInsuranceStatus] = useState(
    vehicle?.insurance_status ? "Active" : "Expired",
  );
  const vehicleId = vehicle?.id;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const statusBoolean = insuranceStatus === "Active" ? true : false;
      // await axios.put(
      //   `https://binberu.idaprocharity.com/api/v1/admin/update-vehicle-insurance-status/${vehicleId}/insurance-status`,
      //   {
      //     insurance_status: statusBoolean,
      //   },
      // );

      const res = await GetVehicle.updateInsurance(statusBoolean, vehicleId);

      setVehicles((prev) =>
        prev.map((v) =>
          v.id === vehicleId ? { ...v, insurance_status: statusBoolean } : v,
        ),
      );

      toast.success("Insurance status updated successfully!");
      setShowModal(false);
    } catch (error) {
      console.error("Error updating insurance status:", error);
      toast.error("Failed to update insurance status. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <div
        style={{
          maxHeight: "80vh",
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "15px",
          borderRadius: "5px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="insurance_status" className="col-form-label">
              Insurance Status
            </label>
            <select
              id="insurance_status"
              name="insurance_status"
              value={insuranceStatus}
              onChange={(e) => setInsuranceStatus(e.target.value)}
              className="form-control"
            >
              <option value="Active">Active</option>
              <option value="Expired">Expired</option>
            </select>
          </div>
          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateInsuranceStatus;
